<template>
  <div>
    <div v-if="school_membership || individual_membership" class="mb-7">
      <!-- Individual Membership -->
      <div v-if="individual_membership" class="bg-gray-50 border border-solid border-gray-200 w-full rounded flex items-center px-6 py-4">
        <div class="w-full">
          <div class=" text-xl font-poppins text-gray-800">
            <span class="font-semibold">You have a Teacher License</span>
          </div>
          <div class="flex justify-between items-center mb-3">
            <div class="font-medium text-gray-800 font-poppins text-sm">
              <p v-if="!individual_membership.is_cancelled && individual_membership.stripe">
                Your license will auto-renew on <span class="font-semibold">{{ individual_membership.expiry_date }}</span>
              </p>
              <p v-else>
                Your license will expire on <span class="font-semibold">{{ individual_membership.expiry_date }}</span>
              </p>
            </div>
          </div>
          <div class="text-gray-600 w-full">
            Learn more about Parlay's
            <a href="https://parlayideas.com/schools-districts/" target="_blank" class="text-pinky hover:underline cursor-pointer">
              memberships and pricing options
            </a>.
          </div>
        </div>
        <div v-if="!individual_membership.is_cancelled && individual_membership.stripe">
          <button @click="handleOpenModalUnsubscribe()" class="bg-pinky text-white rounded px-5 font-semibold h-10 w-64 py-2">
            Cancel Subscription
          </button>
        </div>
      </div>
      <!-- School Membership -->
      <div v-if="school_membership" class="bg-coolGray-100 w-full rounded flex items-center px-6 py-3" :class="[school_membership && individual_membership ? 'mt-3' : '']">
        <div class="w-full">
          <div class="text-xl font-poppins text-gray-800">
            <span class="font-semibold">You have a School License</span>
          </div>
          <div class="flex justify-between items-center mb-3">
            <div>
              <span>{{ school_membership.school_name }}</span>
              <span class="text-gray-800 text-sm font-poppins">
                Your license expires on <span class="font-semibold">{{ school_membership.expiry_date }}</span>
              </span>
            </div>
          </div>
          <div class="text-gray-600 w-full">
            Learn more about Parlay's
            <a href="https://parlayideas.com/schools-districts/" target="_blank" class="text-pinky hover:underline cursor-pointer">
              memberships and pricing options
            </a>.
          </div>
        </div>
      </div>
    </div>
    <div v-else class="mb-6">
      <div class="w-full bg-gray-50 font-poppins border border-solid border-gray-200 rounded px-6 py-4">
        <div class="text-xl mb-1">
          <span class="font-semibold text-gray-800">You have a Free Teacher Account</span>
        </div>
        <div class="text-gray-600 w-full">
          Learn more about Parlay's
          <a href="https://parlayideas.com/schools-districts/" target="_blank" class="text-pinky hover:underline cursor-pointer">
            memberships and pricing options
          </a>.
        </div>
      </div>
    </div>
    <!-- Upgrades Account -->
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 w-full xl:w-7/12 gap-y-5 gap-x-5">
      <!-- Teacher License -->
      <div class="px-7 py-8 bg-gray-50 rounded border border-solid border-gray-200" :class="individual_membership || school_membership ? 'bg-gray-50 bg-opacity-50' : ''">
        <div class="flex flex-col flex-grow">
          <div class="mb-3">
            <h4 class="text-center font-poppins font-semibold text-gray-800 text-lg mb-6">
              Teacher License
            </h4>
            <span class="text-center font-poppins font-light">
              Everything in your free account plus...
            </span>
          </div>
          <div>
            <ul class="list-decimal ml-5">
              <li>Unlimited RoundTables</li>
              <li>RoundTable Data Export</li>
              <li>Student Reports</li>
              <li>Co-Teachers</li>
              <li>Saved Feedback Templates</li>
              <li>Verbal RoundTable Video</li>
            </ul>
          </div>
          <div class="my-6 flex justify-center">
            <span class="text-3xl font-poppins font-bold">$120</span>
            <span class="font-medium flex items-end font-poppins mb-1 ml-1">per year</span>
          </div>
        </div>
        <div class="flex justify-center">
          <button
            @click="subscribe"
            :disabled="individual_membership || school_membership"
            :class="individual_membership || school_membership ? 'bg-pinky cursor-default bg-opacity-50': ''"
            class="bg-pinky rounded px-5 py-2 text-white font-semibold w-full"
          >
            Upgrade Now
          </button>
        </div>
      </div>
      <!-- School License -->
      <div class="px-7 py-8 bg-gray-50 border border-solid border-gray-200 rounded relative" :class="individual_membership || school_membership ? 'bg-gray-50 bg-opacity-50' : ''">
        <h4 class="font-poppins text-center font-semibold text-gray-800 text-lg mb-6">
          School License
        </h4>
        <div class="px-3 text-center">
          <p>
            If your school or district has a license, enter the code below to
            upgrade your account.
          </p>
          <p class="my-6">
            If you don't know your school code, reach out to us in the chat and
            we'll provide it for you.
          </p>
        </div>
        <input
          class="mb-14 bg-white focus:border-pinky disabled:opacity-50 text-gray-500 outline-none flex-grow px-3 py-2 w-full rounded placeholder-gray-300 border border-gray-300"
          placeholder="School Code"
          v-model="school_code"
          @input="error_message = ''"
          :disabled="individual_membership || school_membership"
          :errorMessage="error_message"
        />
        <div class="absolute bottom-8 w-full">
          <button
            @click="submitCode"
            :disabled="individual_membership || school_membership"
            class="bg-pinky rounded px-5 py-2 text-white font-semibold"
            :class="individual_membership || school_membership ? 'bg-pinky cursor-default bg-opacity-50': ''"
            style="width: calc(100% - 56px)"
          >
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
    <ConfirmUnsubscribeModal
      v-if="isModalUnsubscribeOpen === true"
      @close="isModalUnsubscribeOpen = false"
      :dateFinishSubscription="individual_membership.expiry_date"
    />
  </div>
</template>
<script>
  import Vue from 'vue';
  import get from 'lodash/get';
  import { mapGetters, mapActions } from 'vuex';
  import getBillingInformation from 'services/account/getBillingInformation';
  import cancelSubscription from 'services/account/cancelSubscription';
  import { EventBus } from 'utils/event-bus';
  import upgradeUser from 'services/account/upgradeUser';
  import checkout from 'services/account/checkout';
  import store from 'store';
  import amplitude from 'amplitude-js';
  let stripe;

  export default Vue.extend({
    data() {
      return {
        individual_membership: null,
        school_membership: null,
        referral_membership: null,
        user_has_cancelled: false,
        is_loading: true,
        show_confirm_modal: false,
        memberships: [],
        school_code: '',
        error_message: '',
        isModalUnsubscribeOpen: false,
      };
    },
    components: {
      ConfirmUnsubscribeModal: () =>
        import('../ConfirmEndSubscriptionModal.vue'),
    },
    computed: {
      ...mapGetters(['getProfile']),
      new_key() {
        return process.env.NEW_KEY || 'development';
      },
      stripe_key() {
        if (document.URL.includes('go.parlayideas')) {
          return process.env.STRIPE_PRODUCTION_KEY;
        }
        return 'pk_test_4JEaYV8pIXavelVGPKFBeEDl';
      },
      stripeOptions() {
        return {
          // TODO: read from environment variable
          key: this.stripe_key,
          name: 'Parlay Ideas',
          image:
            'https://parlayideas.com/wp-content/uploads/2018/07/Logo-Square.png',
          description: 'Annual Teacher Membership ($120)',
          locale: 'auto',
          currency: 'USD',
          panelLabel: this.panelLabelText,
          // amount: this.amount, // amount in cents
          zipCode: true,
          email: this.getProfile.email,
          allowRememberMe: false,
        };
      },
      // NOTE: The following amount is calculated for display purposes only
      // It does not decide the amount that the user will pay
      // That amount is decided on the backend. The amount is in cents
      panelLabelText() {
        if (this.getProfile.referring_user_id) {
          return 'First year for $90.00';
        }
        return 'Subscribe $120.00 / year';
      },
      hasIndividualAndSchoolLicense() {
        return this.school_membership && this.individual_membership;
      },
    },
    methods: {
      ...mapActions(['upgradeUser']),
      setupStripe: function () {
        window.StripeCheckout
          ? (stripe = window.StripeCheckout.configure(this.stripeOptions))
          : setTimeout(this.setupStripe, 1000);
      },
      checkout: function () {
        stripe.open();
      },
      handleOpenModalUnsubscribe: function () {
        this.isModalUnsubscribeOpen = true;
      },
      handleCancelSubscription: function () {},
      cancelSubscription: function () {
        cancelSubscription()
          .then(() => {
            this.user_has_cancelled = true;
            EventBus.$emit(
              'toast-msg',
              'You have successfully cancelled your Parlay subscription'
            );
          })
          .catch((err) => {
            EventBus.$emit('toast-msg', err.response.data.message);
          });
      },
      loadPage: function () {
        getBillingInformation()
          .then((res) => {
            const { memberships } = res.data;
            this.school_membership = memberships.school_membership;
            this.individual_membership = memberships.individual_membership;
            this.referral_membership = memberships.referral_membership;
            this.memberships = memberships;
            this.is_loading = false;
          })
          .catch(() => {
            this.is_loading = false;
          });
      },
      subscribe: function () {
        this.newStripeImplementation();
      },
      newStripeImplementation: function () {
        checkout().then((res) => {
          const session = res.data;
          sessionStorage.setItem('stripe_session_id', session.id);
          const checkout_url = session.url;
          window.location = checkout_url;
        });
      },
      close: function () {
        this.$emit('close');
      },
      submitCode: function () {
        const userId = this.getProfile.id;
        const payload = { invite_code: this.school_code };
        return upgradeUser(userId, payload)
          .then((res) => {
            if (res.data.show_block_upgrade_modal) {
              this.$store
                .dispatch('getAdminUsersOfSchool', this.school_code)
                .then((res) => {
                  this.adminUsersOfSchool = res;
                  this.show_block_upgrade_modal = true;
                });
            } else if (res.data.show_email_suffixes_modal) {
              this.$store
                .dispatch('getEmailSuffixesOfSchool', this.school_code)
                .then((res) => {
                  this.emailSuffixesOfSchool = res;
                  this.show_email_suffix_block_modal = true;
                });
            } else {
              const school_info = res.data.school_info;
              localStorage.setItem(
                'schoolInfoPostUpgrade',
                JSON.stringify(school_info)
              );
              this.$store.dispatch('upgradeUser', res.data);
              this.loadPage();
              this.close();
              const school = {
                id: res.data.school_info.school_id,
                name: res.data.school_info.school_name,
              };
              EventBus.$emit('show-school-courses-modal', school);
              // send amplitude event
              store.dispatch('analytics', 'teacher - upgrades', {
                payment_type: 'school',
              });
              amplitude
                .getInstance()
                .setUserProperties({ payment_type: 'school', is_paid: true });
              this.school_code = '';
            }
          })
          .catch((e) => {
            const error = get(e, 'response.data.error');
            this.error_message = error || 'Invalid or expired invite code';
            const toast = {
              type: 'Error',
              message: this.error_message,
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          });
      },
    },
    async mounted() {
      await this.setupStripe();
      EventBus.$on('paymentSuccess', async () => {
        await this.loadPage();
      });
      await this.loadPage();
    },
    beforeDestroy() {
      EventBus.$off('paymentSuccess');
    },
  });
</script>



// WEBPACK FOOTER //
// membershipTab.vue?5c6b6084